import type { OrderDto } from '@/services/orders.service';

const clampMarginPercent = (value: unknown): number => {
  const parsed = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(parsed)) {
    return 0;
  }

  return Math.max(0, Math.min(100, Math.trunc(parsed)));
};

const applyMarginPercent = (amountInCents: number, marginPercent: number): number => {
  const base = Math.max(0, Math.round(amountInCents));
  const percent = clampMarginPercent(marginPercent);
  return Math.round((base * (100 + percent)) / 100);
};

export const getPromoDiscountAmountInCents = (order: OrderDto): number => {
  // Backward compatibility for historical orders created before pricingMarginPercent was persisted.
  if (order.pricingMarginPercent == null) {
    return Math.max(0, (order.supplierPrice?.amount ?? 0) - (order.clientPrice?.amount ?? 0));
  }

  const marginPercent = clampMarginPercent(order.pricingMarginPercent);
  const prePromoClientTotal = Array.isArray(order.items) && order.items.length > 0
    ? order.items.reduce((sum, item) => {
        const supplierItemAmount = item.supplierPrice?.amount ?? item.skiPassPrice?.amount ?? 0;
        return sum + applyMarginPercent(supplierItemAmount, marginPercent);
      }, 0)
    : applyMarginPercent(order.supplierPrice?.amount ?? 0, marginPercent);

  return Math.max(0, prePromoClientTotal - (order.clientPrice?.amount ?? 0));
};
